import { useContext, useState, useRef } from "react";

import { Row, Col, Modal, Tooltip } from "antd";
import thumbsupIcon from "../../assets/svgs/thumbs-up-solid.svg"

import checkDarkIcon from "../../assets/svgs/check-dark.svg"
import carotDownIcon from "../../assets/svgs/caret-down-solid.svg"
import xDarkIcon from "../../assets/svgs/x-dark.svg"
import clipboardIcon from "../../assets/svgs/copy-solid.svg"
import commentIcon from "../../assets/svgs/comment-solid.svg"

import { appNotification } from "../common/notification";
import { historyRead, updateFeedback } from "../../api";
import { AppStateContext } from "../../state/AppProvider";
import { redactPIData, trimWholeWordsPastLimit } from "../../utilities/utilities";
import { DateHelper } from "../../utilities/datehelper";

import { searchStatus } from "../../constants/enums";
import { CITATION_HEADINGS_PREFIX } from "../../constants/config";
import React from "react";
// import { unified } from 'unified';
// import remarkParse from 'remark-parse';
// import remarkReact from 'remark-react';

// function MarkdownToReact({ markdown }) {
//     const content = unified()
//         .use(remarkParse)
//         .use(remarkReact, React)
//         .processSync(markdown).result;

//     return <>{content}</>;
// }
interface SearchResultProps {
    isSelected: boolean;
    searchResult: SearchResult;
    searchResultIndex: number;
    selectedSearchResultIndex: number;
    updateFeedbackToSearchResult: (searchResultId: string, feedbackRating: boolean | null, feedbackComment: string) => void
    handleSelectSearchResult: (searchResult: SearchResult) => void
    handleSelectedReference: (reference: SearchResultCitation) => void
    screenSize: number
    currentSearchStatus: searchStatus
    // queryTimeTaken: number
    // index: number
}

const SearchResultItem: React.FC<SearchResultProps> = (props: SearchResultProps) => {
    const appStateContext = useContext(AppStateContext)
    // const [openPopovers, setOpenPopovers] = useState<{ [key: string]: boolean }>({});
    const [openFeedbackComment, setOpenFeedbackComment] = useState<boolean>(false);
    const [feedbackComment, setFeedbackComment] = useState<string>("");
    const [openRecommendations, setOpenRecommendations] = useState<boolean>(false);
    const [openFeedbackCommentModal, setOpenFeedbackCommentModal] = useState<boolean>(false);
    const [copyClipboard, setCopyClipboard] = useState<boolean>(false);
    const copyTimeoutRef = useRef<number | null>(null);

    const beforeSelected = props.searchResultIndex < props.selectedSearchResultIndex;
    const afterSelected = props.searchResultIndex > props.selectedSearchResultIndex;
    const directlyAboveSelected = props.searchResultIndex === props.selectedSearchResultIndex - 1;
    const screenSize = props.screenSize;
    const currentSearchStatus = props.currentSearchStatus;
    // const queryTimeTaken = props.queryTimeTaken;
    // const index = props.index;

    const formatGeneratedText = (generatedTextWithCitations: (string | SearchResultCitation)[] | undefined) => {
        if (!generatedTextWithCitations) return;
        function generateBreaklines(numberOfLines: number) {
            if (typeof numberOfLines !== 'number' || numberOfLines < 0) {
                return <></>;
            }

            const breaklines = [];
            for (let i = 0; i < numberOfLines; i++) {
                breaklines.push(<br key={"b" + i} />);
            }

            return <>{breaklines}</>;
        }
        let breaklinesCnt = 0
        function generateLeadingSpaces(line: string) {

            // Use a regular expression to match leading whitespace
            const match = line.match(/^\s*/);

            // If there's a match, return its length; otherwise, return 0
            const length = match ? match[0].length : 0;

            return (
                <>
                    {Array(length).fill(<React.Fragment>&nbsp;</React.Fragment>)}
                </>
            );
        }
        return generatedTextWithCitations.map((item, item_index) => {
            if (typeof item === "string") {
                // return <MarkdownToReact markdown={item} />
                const lines = item.split('\n');
                return lines.map((line, index) => {
                    if (line.length > 0) {

                        const noOfLines = breaklinesCnt
                        breaklinesCnt = 0
                        return <span key={`${item_index}_${index}`}>
                            {noOfLines > 0 && generateBreaklines(noOfLines)}
                            {generateLeadingSpaces(line)}{line}
                            {lines.length !== index + 1 && <br />}
                        </span>
                    } else {
                        breaklinesCnt++
                        //return <br key={`${item_index}_${index}`} />
                    }
                });
            } else {
                // Citation - open modal directly on click
                const noOfLines = breaklinesCnt
                breaklinesCnt = 0
                return (
                    <span
                        key={item.no}
                        className='cur-pointer c-primary'
                        onClick={() => props.handleSelectedReference(item)}
                    >
                        [{item.no}]
                        {breaklinesCnt > 0 && generateBreaklines(noOfLines)}
                    </span>
                );
            }
        });
    };

    const handleCopyClipboard = () => {
        if (props.searchResult.genratedTextWithInlineCitations && props.searchResult.citations) {
            const mainText = props.searchResult.genratedTextWithInlineCitations?.map(item =>
                typeof item === "string" ? item : `[${item.no}]`
            ).join('') || '';

            const citationText = props.searchResult.citations.map(citation =>
                `[${citation.no}] ${CITATION_HEADINGS_PREFIX}${citation.title}${citation.url ? `\n${citation.url}` : ''}`
            ).join('\n') || '';

            const textToCopy = `${mainText}\n\n${citationText}`;
            navigator.clipboard.writeText(textToCopy);
        }

        setCopyClipboard(true);

        // Clear the existing timeout if it's still running
        if (copyTimeoutRef.current) {
            clearTimeout(copyTimeoutRef.current);
        }

        // Set a new timeout
        copyTimeoutRef.current = setTimeout(() => {
            setCopyClipboard(false);
        }, 2000);
    };

    const displayClassifcations = (classifications: Classification) => {
        return (
            <ol className='c-default ps-3 m-0'>
                {classifications.category3.map((classification, index) => (
                    <li key={index}>{classifications.category1}&nbsp;&gt;&nbsp;{classifications.category2}&nbsp;&gt;&nbsp;{classification}</li>
                ))}
            </ol>)
    }
    const handleFeedback = (searchResult: SearchResult, feedbackRating: boolean | null, feedbackComment: string) => {
        if (feedbackRating == null) {
            feedbackComment = "";
        }
        if (searchResult) {
            updateFeedback({
                message_id: searchResult.messageId!, feedbackRating: feedbackRating, feedbackComment: redactPIData(feedbackComment),
                createdAt: searchResult.generatedTextCreatedAt
            })
                .then((updatedMessage) => {
                    if (updatedMessage) {
                        appNotification.success({ message: "Feedback", description: "Feedback submitted successfully." });
                        props.updateFeedbackToSearchResult(searchResult.id, updatedMessage.feedbackRating!, updatedMessage.feedbackComment!)

                        const chatHistoryItem = appStateContext?.state.chatHistory?.find((h) => h.id === appStateContext?.state.currentChat?.id);
                        if (chatHistoryItem) {
                            chatHistoryItem.messages = chatHistoryItem.messages.map((m) => {
                                if (m.message_id === searchResult.messageId) {
                                    return { ...m, feedbackRating: updatedMessage.feedbackRating, feedbackComment: updatedMessage.feedbackComment }
                                }
                                else
                                    return m;
                            });
                            appStateContext?.dispatch({ type: "UPDATE_CHAT_HISTORY", payload: chatHistoryItem })
                        }
                        else {
                            //get conversation for session and update chat history
                            historyRead(searchResult.id).then((currentConversation) => {
                                if (currentConversation)
                                    appStateContext?.dispatch({ type: "UPDATE_CHAT_HISTORY", payload: currentConversation })
                            })
                        }
                        if (screenSize > 2) {
                            if (feedbackRating != null && feedbackComment == "") {
                                setOpenFeedbackComment(true);
                            } else {
                                setOpenFeedbackComment(false);
                            }
                        } else {
                            if (feedbackRating != null && feedbackComment == "") {
                                setOpenFeedbackCommentModal(true);
                            } else {
                                setOpenFeedbackCommentModal(false);
                            }
                        }
                    }
                });
        }
    }
    const handleFeedbackSubmit = (searchResult: SearchResult) => {
        if (feedbackComment.trim()) {
            handleFeedback(searchResult, searchResult?.feedbackRating ?? null, feedbackComment);
            setOpenFeedbackComment(false);
            setOpenFeedbackCommentModal(false);
            setFeedbackComment("");
        }
    };

    if (props.isSelected) {
        function scrollToCloseIcon() {
            const closeIcon = document.querySelector('#closeIcon');
            if (closeIcon) {
                closeIcon.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else {
                setTimeout(scrollToCloseIcon, 100);
            }
        }

        return (
            <>
                {screenSize > 2 ? (
                    <div key={props.searchResult.id} className='bg-root p-2 ps-3 pe-3 br-tl-16 br-bl-16 b-2F4250'>
                        <div className='d-flex'>
                            <div id='user-query' className='fs20-fw600 c-primary me-auto'>
                                {props.searchResult?.userQuery}
                            </div>
                            {/* <div className="c-default" style={{ whiteSpace: 'nowrap' }}>
                                {index === 0 && import.meta.env.VITE_APP_SHOW_QUERY_TIMETAKEN === "ENABLED" && `${queryTimeTaken.toFixed(1)} s`}
                            </div> */}
                            <div style={{ whiteSpace: 'nowrap' }} className='fs16-fw600 c-default fs12-fw600 bg-2F4334 ms-2 h-fit-content p-1 ps-2 pe-2 br-16'>
                                {props.searchResult.generatedTextCreatedAt ? DateHelper.formatDateTime(props.searchResult.generatedTextCreatedAt) : ''}</div>
                            {currentSearchStatus == searchStatus.Inactive && <div style={{ whiteSpace: 'nowrap' }} className='fs16-fw600 c-default ms-2 fs12-fw600 bg-2F4334 h-fit-content p-1 ps-2 pe-2 br-16'>
                                {props.searchResult.generatedTextCreatedAt ? DateHelper.formatDate(props.searchResult.generatedTextCreatedAt) : ''}</div>}
                        </div>
                        <div className='fs14-fw400 c-default'>
                            {formatGeneratedText(props.searchResult.genratedTextWithInlineCitations)}
                        </div>
                        {((import.meta.env.VITE_APP_SHOW_RECOMMENDATION === "ENABLED" && props.searchResult?.classification?.category3 && props.searchResult.classification.category3.length > 0) || (props.searchResult?.classification?.escalation_party)) &&
                            (
                                <div className='mt-1 bg-2F4334 br-16'>
                                    <div className='c-primary fs16-fw600 t-a-center pt-2'>Recommendations</div>
                                    <div className='d-flex p-3 g-2 pt-1'>
                                        {props.searchResult?.classification?.category3 && props.searchResult.classification.category3.length > 0 &&
                                            <div className={`rec-section d-flex-grow fs14-fw400`}>
                                                <div className={`c-default fs14-fw600`}>Categories</div>
                                                {displayClassifcations(props.searchResult.classification)}
                                            </div>
                                        }
                                        {props.searchResult?.classification?.escalation_party &&
                                            <div className={`esc-sectiond-flex-grow`}>
                                                <div className={`c-default fs14-fw600`}><div>Escalation Party</div></div>
                                                <div className='c-default fs14-fw400'>{props.searchResult.classification.escalation_party}</div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            )
                        }
                        <div className='mt-2 d-flex g-2 feedback-section'>
                            {(props.searchResult.citations ?? []).length > 0 &&
                                (
                                    <button className='mt-1 h-fit-content'>
                                        {copyClipboard ?
                                            (
                                                <Tooltip title="Copied">
                                                    <img src={checkDarkIcon} style={{ height: '14px' }} onClick={handleCopyClipboard} className='filter-white-primary o-50' alt="" />
                                                </Tooltip>
                                            ) : (
                                                <Tooltip title="Copy">
                                                    <img src={clipboardIcon} style={{ height: '18px' }} onClick={handleCopyClipboard} className='filter-white-primary o-50' alt="" />
                                                </Tooltip>
                                            )
                                        }
                                    </button>
                                )
                            }
                            <div className='mt-1'>
                                {props.searchResult.feedbackRating ? (
                                    <button className='' onClick={() => handleFeedback(props.searchResult, null, "")}><img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                ) : props.searchResult.feedbackRating === false ? (
                                    <button className='o-20' onClick={() => handleFeedback(props.searchResult, true, "")}><img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                ) : (
                                    <button className='o-50' onClick={() => handleFeedback(props.searchResult, true, "")}><img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                )}
                            </div>

                            <div className='mt-2'>
                                {props.searchResult.feedbackRating ? (
                                    <button className='o-20' onClick={() => handleFeedback(props.searchResult, false, "")}><img className='filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                ) : props.searchResult.feedbackRating == false ? (
                                    <button className='' onClick={() => handleFeedback(props.searchResult, null, "")}><img className='filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                ) : (
                                    <button className='o-50' onClick={() => handleFeedback(props.searchResult, false, "")}><img className='filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                )}
                            </div>

                            <div className='d-flex-grow d-flex'>
                                {openFeedbackComment ? (
                                    <div className='d-flex h-100 g-2 me-1 d-flex-grow'>
                                        <input
                                            className='bg-root b-primary br-16 input-primary c-default w-100 ps-2 pe-2'
                                            type="text"
                                            value={feedbackComment}
                                            onChange={(e) => setFeedbackComment(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleFeedbackSubmit(props.searchResult);
                                                }
                                            }}
                                        />
                                        <button
                                            className='filter-primary'
                                            onClick={() => { setFeedbackComment(""); setOpenFeedbackComment(false); }}
                                        >
                                            <img src={xDarkIcon} alt="" />
                                        </button>
                                        <button
                                            className='filter-primary'
                                            onClick={() => { handleFeedbackSubmit(props.searchResult) }}
                                        >
                                            <img src={checkDarkIcon} alt="" />
                                        </button>
                                    </div>
                                ) : (
                                    <div className='c-default fs12-fw400 my-auto'>{props.searchResult.feedbackComment}</div>
                                )}
                            </div>

                        </div>
                    </div>
                ) : (
                    <div key={props.searchResult.id} className='bg-white-a-50 pt-2 b-2F4250'>
                        <Row className='pe-3 ps-3' style={{ position: 'relative' }}>
                            <Col span={19}>
                                <div id='user-query' className='fs16-fw600 c-primary'>
                                    {props.searchResult?.userQuery}
                                </div>
                                <div className='fs12-fw400 c-default' id='generated-text'>
                                    {formatGeneratedText(props.searchResult.genratedTextWithInlineCitations)}
                                </div>
                            </Col>
                            <Col span={5} className='d-flex d-flex-column g-2' style={{ alignItems: 'center' }}>

                                <div style={{ whiteSpace: 'nowrap' }} className='b-primary-thin fs10-fw600 c-default mx-auto bg-2F4334 h-fit-content p-1 ps-2 pe-2 br-16'>
                                    {props.searchResult.generatedTextCreatedAt ? DateHelper.formatDateTime(props.searchResult.generatedTextCreatedAt) : ''}</div>

                                <div className='d-flex d-flex-column g-2 w-fit-content' style={{ position: 'relative', right: '0rem', bottom: '0rem' }}>
                                    {currentSearchStatus == searchStatus.Inactive && <div style={{ whiteSpace: 'nowrap' }} className='b-primary-thin fs10-fw600 c-default mx-auto bg-2F4334 h-fit-content p-1 ps-2 pe-2 br-16'>
                                        {props.searchResult.generatedTextCreatedAt ? DateHelper.formatDate(props.searchResult.generatedTextCreatedAt) : ''}</div>}
                                    {(props.searchResult.citations ?? []).length > 0 &&
                                        (
                                            <button className='mx-auto'>
                                                {copyClipboard ?
                                                    (
                                                        <img src={checkDarkIcon} style={{ height: '18px' }} onClick={handleCopyClipboard} className='filter-white-primary o-50' alt="" />
                                                    ) : (
                                                        <img src={clipboardIcon} style={{ height: '20px' }} onClick={handleCopyClipboard} className='filter-white-primary o-50' alt="" />
                                                    )
                                                }
                                            </button>
                                        )
                                    }
                                    <div className='mx-auto'>
                                        {props.searchResult.feedbackRating ? (
                                            <button className='' onClick={() => handleFeedback(props.searchResult, null, "")}><img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                        ) : props.searchResult.feedbackRating === false ? (
                                            <button className='o-20' onClick={() => handleFeedback(props.searchResult, true, "")}><img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                        ) : (
                                            <button className='o-50' onClick={() => handleFeedback(props.searchResult, true, "")}><img className='flip180deg filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                        )}
                                    </div>

                                    <div className='mx-auto'>
                                        {props.searchResult.feedbackRating ? (
                                            <button className='o-20' onClick={() => handleFeedback(props.searchResult, false, "")}><img className='filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                        ) : props.searchResult.feedbackRating == false ? (
                                            <button className='' onClick={() => handleFeedback(props.searchResult, null, "")}><img className='filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                        ) : (
                                            <button className='o-50' onClick={() => handleFeedback(props.searchResult, false, "")}><img className='filter-white-primary' src={thumbsupIcon} alt="" /></button>
                                        )}
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {props.searchResult.feedbackComment &&
                            (
                                <div className='ms-3 d-flex mt-1 pb-1'>
                                    <img className='filter-primary' src={commentIcon} style={{ height: '16px' }} alt="" />
                                    <div className='c-default fs12-fw400 my-auto ms-2'>{props.searchResult.feedbackComment}</div>
                                </div>
                            )
                        }

                        {((import.meta.env.VITE_APP_SHOW_RECOMMENDATION === "ENABLED" && props.searchResult?.classification?.category3 && props.searchResult.classification.category3.length > 0) || (import.meta.env.VITE_APP_SHOW_RECOMMENDATION === "ENABLED" && props.searchResult?.classification?.escalation_party)) &&
                            <>
                                {openRecommendations ?
                                    (
                                        <div className='mt-1 bg-2F4334'>
                                            <div className='c-primary fs14-fw600 t-a-center pt-2'>Recommendations</div>
                                            <div className='d-flex p-0 pe-2 ps-2 g-2 pt-1'>
                                                {props.searchResult?.classification?.category3 && props.searchResult.classification.category3.length > 0 &&
                                                    <div className={`rec-section d-flex-grow fs12-fw400`}>
                                                        <div className={`c-default fs12-fw600`}>Categories</div>
                                                        {displayClassifcations(props.searchResult.classification)}
                                                    </div>
                                                }
                                                {props.searchResult?.classification?.escalation_party &&
                                                    <div className={`esc-sectiond-flex-grow`}>
                                                        <div className={`c-default fs12-fw600`}><div>Escalation Party</div></div>
                                                        <div className='c-default fs12-fw400'>{props.searchResult.classification.escalation_party}</div>
                                                    </div>
                                                }
                                            </div>
                                            <div className='d-flex'>
                                                <button id='closeIcon' className='mx-auto w-100' onClick={() => { setOpenRecommendations(false) }}>
                                                    <img className='mx-auto flip180deg' src={carotDownIcon} alt="" />
                                                </button>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className='mt-2 bg-2F4334 d-flex'>
                                            <button className='mx-auto w-100' onClick={() => { setOpenRecommendations(true); scrollToCloseIcon(); }}>
                                                <img className='mx-auto' src={carotDownIcon} alt="" />
                                            </button>
                                        </div>
                                    )
                                }

                            </>
                        }
                        <Modal
                            title={
                                <div style={{ display: 'flex' }}>
                                    <div className="ant-modal-title">Comment</div>
                                </div>
                            }
                            style={{
                                borderRadius: '16px',
                                padding: '0px',
                                boxShadow: '0px 10px 20px -8px #392EA433'
                            }}
                            className={`custom-modal c-default ${(appStateContext?.state?.screenSize ?? 3) < 3 ? 'small-screen-modal' : ''}`}
                            okButtonProps={{
                                className: 'bg-primary br-16 c-root pt-2 pb-2 pt-2 pb-2'
                            }}
                            cancelButtonProps={{
                                className: 'bg-root br-16 c-primary b-primary pt-2 pb-2 pt-2 pb-2'
                            }}
                            open={openFeedbackCommentModal}
                            onOk={() => {
                                handleFeedbackSubmit(props.searchResult);
                                setOpenFeedbackCommentModal(false);
                            }}
                            onCancel={() => { setFeedbackComment(""); setOpenFeedbackCommentModal(false) }}
                            okText="Comment"
                            cancelText="Cancel"
                        >
                            <textarea
                                className='bg-root b-primary br-16 input-primary c-default w-90 ps-2 pe-2'
                                value={feedbackComment}
                                rows={4}
                                onChange={(e) => setFeedbackComment(e.target.value)}
                            />
                        </Modal>
                    </div>
                )

                }

            </>

        )
    } else {
        return (
            <>
                {screenSize > 2 ?
                    (
                        <div
                            className={`beforeSelected-${beforeSelected} afterSelected-${afterSelected} cur-pointer w-90 bg-root o-60 p-2 pe-3 ps-3 ms-auto b-left-2F4250 b-right-2F4250 ${props.searchResultIndex === 0 && !directlyAboveSelected ? 'b-top-2F4250 b-bottom-2F4250' : directlyAboveSelected ? 'b-bottom-none' : 'b-bottom-2F4250'}`}
                            onClick={() => {
                                props.handleSelectSearchResult(props.searchResult)
                                setFeedbackComment("");
                                setOpenFeedbackComment(false);
                            }}>
                            <div className='d-flex'>
                                <div className='fs16-fw600 c-primary'>{props.searchResult.userQuery}</div>
                                <div style={{ whiteSpace: 'nowrap' }} className='fs16-fw600 c-default ms-auto fs12-fw600 bg-2F4334 h-fit-content p-1 ps-2 pe-2 br-16'>
                                    {props.searchResult.generatedTextCreatedAt ? DateHelper.formatDateTime(props.searchResult.generatedTextCreatedAt) : ''}</div>
                            </div>
                            <div className='fs14-fw400 c-default'>{trimWholeWordsPastLimit(props.searchResult.generatedText ?? "", 200)}</div>
                        </div>
                    ) : (
                        <div
                            className={`cur-pointer bg-root o-60 p-2 pe-3 ps-3 ms-auto b-right-2F4250 ${props.searchResultIndex === 0 && !directlyAboveSelected ? 'b-top-2F4250 b-bottom-2F4250' : directlyAboveSelected ? 'b-bottom-none' : 'b-bottom-2F4250'}`}
                            onClick={() => {
                                props.handleSelectSearchResult(props.searchResult)
                                setFeedbackComment("");
                                setOpenFeedbackComment(false);
                            }}>
                            <div className='d-flex justify-content-between'>
                                <div className='fs14-fw600 c-primary'>{props.searchResult.userQuery}</div>
                                <div style={{ whiteSpace: 'nowrap' }} className='b-primary-thin fs10-fw600 c-default bg-2F4334 h-fit-content p-1 ps-2 pe-2 br-16'>
                                    {props.searchResult.generatedTextCreatedAt ? DateHelper.formatDateTime(props.searchResult.generatedTextCreatedAt) : ''}
                                </div>
                            </div>
                            <div className='fs12-fw400 c-default'>{trimWholeWordsPastLimit(props.searchResult.generatedText ?? "", 200)}</div>
                        </div>
                    )

                }

            </>
        )
    }
}

export default SearchResultItem